<div class="footer-copyright text-center mt-3 pb-2">
	<span style="font-size: medium">© 2024 Copyright Predimed Technology</span>
</div>
